import React from "react";

export default function ChiSiamo() {
  return (
    <div>
      {/* Prima sezione con immagine undraw_contact-us.svg */}
      <section className="astronaut_section pb-40 pt-20 bg-[#fbfef5] min-h-[800px] bg-no-repeat bg-center bg-cover">
        <div className="container-xl mx-auto px-0 flex justify-between items-center max-w-7xl max-w-[85%] gap-15 flex-col lg:flex-row">
          
          {/* Left side */}
          <div className="w-full lg:w-1/2 text-lg mb-8 lg:mb-0">
            <h1 className="titolo-style mb-6 text-left">
              <span className="text-[#131904]" style={{ marginBottom: '0px', display: 'block', fontSize: '48px'}}>
                La piattaforma smart,
              </span>
              <span className="text-[#94c41c]" style={{ marginTop: '0px', display: 'block', fontSize: '48px'}}>
                per il dominio che cerchi.
              </span>
            </h1>
            <p className="regular-text text-left text-[#131904] max-w-full mx-auto block" style={{ fontSize: '20px' }}>
              Seeurl è la piattaforma semplice e veloce per trovare e acquistare il dominio perfetto.
              <br></br><br></br>
              Progettata per chi cerca chiarezza e efficienza, offre strumenti intuitivi e filtri avanzati per facilitare ogni ricerca, garantendo un’esperienza d’acquisto rapida e senza intoppi.
            </p>
          </div>

          {/* Right side (Image) */}
          <div className="w-full lg:w-1/2">
            <img
              src="/static/immagine_chisiamo_1.svg"
              alt="Digital Domain"
              className="max-w-full h-auto"
            />
          </div>
        </div>
      </section>

      {/* Separatore ondulato tra le due parti */}
      <div className="relative bg-[#fbfef5] mt-10">
        <div className="absolute bottom-0 left-0 w-full z-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            height="120"
            width="100%"
            preserveAspectRatio="none"
            className="block w-full h-full"
          >
            <path
              fill="#f3f9e4"
              d="M0,60 C650,-100 800,180 1200,60 L1200,120 L0,120 Z"
            />
          </svg>
        </div>
      </div>

      {/* Seconda sezione con immagine undraw_contact-us.svg */}
      <section className="astronaut_section pb-80 pt-0 bg-[#f3f9e4] min-h-[800px] bg-no-repeat bg-center bg-cover">
        <div className="container-xl mx-auto px-0 flex justify-between items-center max-w-7xl max-w-[85%] gap-15 flex-col lg:flex-row">
          
          {/* Left side (Image) */}
          <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
            <img
              src="/static/immagine_chisiamo_2.svg"
              alt="Digital Domain"
              className="max-w-full h-auto"
            />
          </div>

          {/* Right side (Text) */}
          <div className="w-full lg:w-1/2 text-lg">
            <h2 className="titolo-style mb-6 text-left">
              <span className="text-[#131904]" style={{ marginBottom: '0px', display: 'block', fontSize: '48px'}}>
                La nostra mission?
              </span>
              <span className="text-[#94c41c]" style={{ marginTop: '0px', display: 'block', fontSize: '48px'}}>
                Semplificare i domini.
              </span>
            </h2>
            <p className="regular-text text-left text-[#131904] max-w-full mx-auto block" style={{ fontSize: '20px' }}>
              La nostra mission è rendere la registrazione e la gestione dei domini semplice, sicura e alla portata di tutti; senza ostacoli e senza sorprese.
              <br></br><br></br>
              Puntiamo su chiarezza e trasparenza, perché crediamo che un web migliore inizi da qui: da un servizio onesto, accessibile e costruito per chi vuole davvero crescere online.
            </p>
          </div>
        </div>
      </section>

      {/* Separatore ondulato tra le due parti */}
      <div className="relative bg-[#fbfef5] mt-0">
        <div className="absolute bottom-0 left-0 w-full z-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            height="120"
            width="100%"
            preserveAspectRatio="none"
            className="block w-full h-full"
          >
            <path
              fill="#fbfef5"
              d="M0,60 C650,-100 800,180 1200,60 L1200,120 L0,120 Z"
            />
          </svg>
        </div>
      </div>

      {/* Terza sezione con immagine undraw_contact-us.svg */}
      <section className="astronaut_section pb-40 pt-20 bg-[#fbfef5] min-h-[800px] bg-no-repeat bg-center bg-cover">
        <div className="container-xl mx-auto px-0 flex justify-between items-center max-w-7xl max-w-[85%] gap-15 flex-col lg:flex-row">
          
          {/* Left side */}
          <div className="w-full lg:w-1/2 text-lg mb-8 lg:mb-0">
            <h2 className="titolo-style mb-6 text-left">
              <span className="text-[#131904]" style={{ marginBottom: '0px', display: 'block', fontSize: '48px'}}>
                Non solo tecnologia,
              </span>
              <span className="text-[#94c41c]" style={{ marginTop: '0px', display: 'block', fontSize: '48px'}}>
                ma persone al tuo fianco.
              </span>
            </h2>
            <p className="regular-text text-left text-[#131904] max-w-full mx-auto block" style={{ fontSize: '20px' }}>
              Seeurl non è solo una piattaforma per acquistare domini, è un servizio costruito da persone reali, con competenze vere e un approccio concreto.
              <br></br><br></br>
              Dietro ogni ricerca, acquisto o richiesta c'è un team pronto ad ascoltarti, rispondere con chiarezza e accompagnarti passo dopo passo.
            </p>
          </div>

          {/* Right side (Image) */}
          <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
            <img
              src="/static/immagine_chisiamo_3.svg"
              alt="Digital Domain"
              className="max-w-full h-auto"
            />
          </div>
        </div>
      </section>

      {/* Separatore ondulato tra le due parti */}
      <div className="relative bg-[#fbfef5] mt-10">
        <div className="absolute bottom-0 left-0 w-full z-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            height="120"
            width="100%"
            preserveAspectRatio="none"
            className="block w-full h-full"
          >
            <path
              fill="#f3f9e4"
              d="M0,60 C650,-100 800,180 1200,60 L1200,120 L0,120 Z"
            />
          </svg>
        </div>
      </div>

<section className="astronaut_section pb-20 pt-40 bg-[#f3f9e4] min-h-[600px] bg-no-repeat bg-center bg-cover">
  <div className="container-xl mx-auto px-0 flex justify-between items-center max-w-7xl max-w-[85%] gap-15">
    
    {/* Left side */}
    <div className="hidden lg:flex lg:w-1/2 items-center justify-center">
      <div className="w-1/3 p-6"> {/* Aumentato il padding */}
        <img
          src="/static/logo-seeurl.svg"
          alt="Digital Domain 1"
          className="max-w-full h-auto"
        />
      </div>
      
{/* Separatore verticale cicciotto al centro */}
<div className="relative flex justify-center items-center">
  <div
    style={{
      width: '1px', // Linea più sottile
      height: '100px',
      background: 'linear-gradient(to top, transparent 0%, #000 40%, #000 60%, transparent 100%)', // Dissolvenza sopra e sotto, pieno al centro
      borderRadius: '999px',
      margin: '0 15px', // Spazio tra le immagini e il separatore
    }}
  ></div>
</div>
      
      <div className="w-1/3 p-6"> {/* Aumentato il padding */}
        <img
          src="/static/logo_vay_quadrato.svg"
          alt="Digital Domain 2"
          className="max-w-full h-auto"
        />
      </div>
    </div>

    {/* Right side (Text) */}
    <div className="w-full lg:w-1/2 text-lg">
      <h2 className="titolo-style mb-6 text-left">
        <span className="text-[#131904]" style={{ marginBottom: '0px', display: 'block', fontSize: '48px'}}>
          Seeurl è un marchio Vay,
        </span>
        <span className="text-[#94c41c]" style={{ marginTop: '0px', display: 'block', fontSize: '48px'}}>
          sinonimo di qualità.
        </span>
      </h2>
      <p className="regular-text text-left text-[#131904] max-w-full mx-auto block" style={{ fontSize: '20px' }}>
        Seeurl nasce da Vay, un’azienda che dal 2010 porta innovazione e concretezza nel mondo IT.
        <br/><br/>
        Dietro ogni dominio, c’è l’esperienza di chi da anni aiuta imprese e professionisti a crescere con soluzioni su misura, tecnologicamente evolute e umanamente vicine.
      </p>
    </div>
  </div>
</section>

<section className="bg-[#95c11f] text-center py-20 pt-40 pb-40">
  <div className="container-xl mx-auto px-6 max-w-3xl max-w-[85%]">
    {/* Titolo con doppia riga e doppio colore */}
    <h2 className="titolo-style text-center text-5xl text-black mb-6">
      <span className="block text-[#131904]" style={{ marginBottom: '10px', display: 'block', fontSize: '55px' }}>
        Cerca, trova, acquista.
      </span>
      <span className="block text-[#fbfef5]" style={{ marginTop: '10px', display: 'block', fontSize: '55px' }}>
        Ottieni il dominio perfetto!
      </span>
    </h2>

    {/* Search Form */}
    <div className="mt-12 flex justify-center">
      <form
        action="../search-results"
        acceptCharset="UTF-8"
        method="get"
        className="w-full max-w-[100%] sm:max-w-[70%] md:max-w-[50%] lg:max-w-[40%] xl:max-w-[35%]"
      >
        <div
          className="relative flex overflow-hidden h-18 border-2 bg-[#fbfef5]"
          style={{
            borderRadius: '20px', // Applica la rotondità direttamente al div
          }}
        >
          <input
            type="text"
            name="terms"
            id="terms"
            placeholder="Cerca qui il tuo dominio ideale..."
            className="flex-grow px-6 py-4 text-xl text-[#4b6f32] focus:outline-none h-full placeholder-white"
            style={{ fontSize: '18px', color: '#869d4a' }}
          />
          <button
            type="submit"
            style={{
              color: '#869d4a',
              padding: '0px 20px',
              borderTopLeftRadius: '0',
              borderBottomLeftRadius: '0',
              borderTopRightRadius: '20px',
              borderBottomRightRadius: '20px',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.3s',
            }}
          >
            <svg
              style={{ width: '35px', height: '35px' }}
              fill="none"
              stroke="#869d4a"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="11" cy="11" r="7" strokeLinecap="round" strokeLinejoin="round" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </form>
    </div>
  </div>
</section>

    </div>
  );
}
